// extracted by mini-css-extract-plugin
module.exports = {"timer":"timer_timer__2oXym"};